﻿import type { Config as PuckConfig } from "@measured/puck";
import HeadingBlock from "@digitalopsdev/serviceops-docs-components/dist/blocks/HeadingBlock";
import TextBlock from "@digitalopsdev/serviceops-docs-components/dist/blocks/TextBlock";
import ActivitiesWeeklySummary from "./ActivitiesWeeklySummaryBlock";
import ActivitiesList from "./ActivitiesListBlock";
import ActivityHeader from "./ActivityHeaderBlock";
import ActivityTile from "./ActivityTileBlock";
import ActivitySparkline from "./ActivitySparklineBlock";
import ActivityRow from "./ActivityRowBlock";
import Container from "@digitalopsdev/serviceops-docs-components/dist/blocks/ContainerBlock";
import ActivitiesAsyncGate from "./ActivitiesAsyncGateBlock";
import LoadingSpinner from "@digitalopsdev/serviceops-docs-components/dist/blocks/LoadingSpinnerBlock";
import HrmLoanAlert from "./HrmLoanAlertBlock";
// Weekly summary blocks (consolidated)
import WeeklyStatTile from "./WeeklyStatTileBlock";
import WeeklyLoadsBar from "./WeeklyLoadsBarBlock";
// Legacy tiles kept for backward compatibility (not shown in palette)
import WeeklySessionsTile from "./WeeklySessionsTileBlock";
import WeeklyLoadTile from "./WeeklyLoadTileBlock";
import WeeklyMonotonyTile from "./WeeklyMonotonyTileBlock";
import WeeklyDecisionTile from "./WeeklyDecisionTileBlock";
 
export const activitiesPuckConfig: PuckConfig = {
  categories: {
    activities: {
      title: "Activities",
      components: [
        // HRM loan alert (shows only when guest has HRM on loan)
        "HrmLoanAlert",
        // Unified weekly stat tile and weekly bar
        "WeeklyStatTile",
        "WeeklyLoadsBar",
        // Activity item and list blocks
        "ActivitiesList",
        "ActivityHeader",
        "ActivityTile",
        "ActivitySparkline",
        "ActivityRow",
        "ActivitiesAsyncGate",
      ],
    },
    typography: {
      components: ["HeadingBlock", "TextBlock"],
    },
    layout: {
      title: "Layout",
      components: ["Container"],
    },
    feedback: {
      title: "Feedback",
      components: ["LoadingSpinner"],
    },
  },
  components: {
    HeadingBlock: HeadingBlock as any,
    TextBlock: TextBlock as any,
    // Keep ActivitiesWeeklySummary for backward compatibility with existing layouts
    ActivitiesWeeklySummary: ActivitiesWeeklySummary as any,
    ActivitiesList: ActivitiesList as any,
    ActivityHeader: ActivityHeader as any,
    ActivityTile: ActivityTile as any,
    ActivitySparkline: ActivitySparkline as any,
    ActivityRow: ActivityRow as any,
    Container: Container as any,
    ActivitiesAsyncGate: ActivitiesAsyncGate as any,
    LoadingSpinner: LoadingSpinner as any,
    HrmLoanAlert: HrmLoanAlert as any,
    // Unified weekly stat tile + weekly bar
    WeeklyStatTile: WeeklyStatTile as any,
    WeeklyLoadsBar: WeeklyLoadsBar as any,
    // Legacy tiles kept for backward compatibility (hidden from palette)
    WeeklySessionsTile: WeeklySessionsTile as any,
    WeeklyLoadTile: WeeklyLoadTile as any,
    WeeklyMonotonyTile: WeeklyMonotonyTile as any,
    WeeklyDecisionTile: WeeklyDecisionTile as any,
  },
};

export function getActivitiesPuckConfig(): PuckConfig {
  return activitiesPuckConfig;
}
